/**
 * Formats job number and revision for display
 * Special handling: rev 999 displays as "Erosion" instead of "Rev999"
 *
 * @param {string|number} jobNumber - The project job number
 * @param {string|number} rev - The project revision number
 * @param {string} defaultValue - Default value if jobNumber is missing (default: 'N/A')
 * @returns {string} Formatted job number with revision
 */
export const formatJobRevNumber = (jobNumber, rev, defaultValue = 'N/A') => {
  if (!jobNumber) return defaultValue;

  const revNumber = parseInt(rev);

  if (revNumber === 999) {
    return `${jobNumber} Erosion`;
  }

  if (rev && revNumber > 0) {
    return `${jobNumber} Rev${rev}`;
  }

  return jobNumber;
};
